<template>
    <div class="card">
        <div v-for="(itemList, idx) in timeList" :key="idx" class="column">
            <div v-for="(item, idx1) in itemList" :key="item.time" class="row" :style="item.style">
                <div class="context">
                    <div class="time">{{ item.time }}</div>
                    <div v-for="(imgItem, idx2) in item.imgList" :key="idx2" class="image"
                        :class="{ 'mb-12': idx2 !== item.imgList.length - 1 }">
                        <img :src="imgItem" class="image" />
                    </div>
                    <ul class="peoples">
                        <li v-for="(people, idx3) in item.peopleList" 
                            :key="idx3" class="people" :class="{ 'mb-37': idx3 !== item.peopleList.length - 1 }">
                            <span class="name">{{ people.name }}</span>
                            <span class="text">{{ people.intro }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jiabinqiaoDao from "@/assets/img/jinju-2024/huodong_title_jiabin@2x.png"
import zhubanfanzhici from "@/assets/img/jinju-2024/huodong_title_zhici@2x.png"
import zhutiyanjiang from "@/assets/img/jinju-2024/huodong_title_yanjiang@2x.png"
import yuanzhuoluntang from "@/assets/img/jinju-2024/huodong_title_zhuti@2x.png"
import chaxiejiaoliu from "@/assets/img/jinju-2024/huodong_title_chaxie@2x.png"
import jinjujiang from "@/assets/img/jinju-2024/huodong_title_jinjujiang@2x.png"
import yewanyan from "@/assets/img/jinju-2024/huodong_title_time@2x.png"

export default {
    data() {
        return {
            timeList: [
                [
                    {
                        time: "13:45-14:00", imgList: [jiabinqiaoDao],
                        style: { background: "#09205D" }, peopleList: []
                    },
                    {
                        time: "14:00-14:10", imgList: [zhubanfanzhici],
                        style: { background: "rgba(9, 32, 93, .2)" }, peopleList: [
                            { name: "孙波", intro: "广东时代传媒集团有限公司党委书记、董事长" },
                        ]
                    },
                ],
                [
                    {
                        time: "14:10-16:30", imgList: [zhutiyanjiang],
                        style: { background: "rgba(9, 32, 93, .2)" },
                        peopleList: [
                            { name: "魏建国", intro: "中国国际经济交流中心副理事长兼常务副主任、商务部原副部长" },
                            { name: "张慎峰", intro: "中国国际贸易促进委员会原副会长、证监会原主席助理" },
                            // { name: "涂宏", intro: "交通银行业务总监 上海市分行党委书记、行长" },
                            { name: "王庆", intro: "上海重阳投资管理股份有限公司董事长兼首席经济学家" },
                            { name: "芦哲", intro: "方正证券首席经济学家" },
                            { name: "栾广富", intro: "正泰集团轮值总裁" },
                        ]
                    },
                    {
                        time: "16:30-17:30", imgList: [yuanzhuoluntang],
                        style: { background: "#09205D" }, peopleList: [
                            { name: "高雨", intro: "闻泰科技董事会秘书" },
                            { name: "郭彦辰", intro: "方正证券电新行业首席分析师" },
                            { name: "宋巍巍", intro: "中欧基金指数基金经理" },
                            { name: "常阳", intro: "晶科电力科技董事会秘书" },
                            { name: "常虹", intro: "东方中科副总经理、董事会秘书" },
                            { name: "宋倩", intro: "江苏银行科技金融部总经理助理" },
                        ]
                    }
                ],
                [
                    {
                        time: "17:30", imgList: [chaxiejiaoliu],
                        style: { background: "#09205D" }, peopleList: []
                    },
                    {
                        time: "18:30-19:30", imgList: [jinjujiang, yewanyan],
                        style: { background: "rgba(9, 32, 93, .2)" }
                    },
                ],
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.card {

    .mb-12 {
        margin-bottom: 12px !important;
    }

    .mb-37 {
        margin-bottom: 37px !important;
    }

    .column {
        display: flex;

        .row {
            width: 50%;

            .context {
                padding: 30px 5px 30px 64px ;

                .time {
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    font-size: 26px;
                    color: #ADB7C3;
                    line-height: 28px;
                    margin-bottom: 23px;
                }

                .image {
                    height: 16px;
                    width: auto;
                    margin-bottom: 28px;
                }

                .peoples {
                    .people {
                        display: flex;
                        flex-direction: column;

                        .name {
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;
                            line-height: 28px;
                            position: relative;
                            margin-right: 14px;

                            &::before {
                                content: "";
                                position: absolute;
                                left: -15px;
                                top: 50%;
                                transform: translateY(-50%);
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                background: #3DD0F5;
                                margin-top: 2px;
                            }
                        }

                        .text {
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 15px;
                            color: #FFFFFF;
                            line-height: 28px;
                            opacity: 0.8;
                        }
                    }
                }
            }
        }
    }
}
</style>